<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <div class="d-flex align-items-center justify-content-between mb-3 mt-3">
        <b-button variant="secondary" class="ml-2" @click="$router.go(-1)">
          <i class="fas fa-arrow-left"></i> {{ $t('volver') }}
        </b-button>
        <div class="d-flex" style="gap:8px;">
          <b-button v-if="editMode && puedeEditar" @click.prevent="submitForm" variant="primary">
            <i class="fas fa-save mr-1"></i> {{ $t('guardar') }}
          </b-button>
          <!-- Sin permiso de edición la pantalla queda en modo consulta. -->
          <base-button v-if="puedeEditar" :type="editMode ? 'danger' : 'warning'" @click="cancelEdit">
            {{ editMode ? $t('cancelar') : $t('editar') }}
          </base-button>
        </div>
      </div>

      <b-container style="max-width: 90%; margin: auto;">

        <b-card-header class="border-0">
          <h3 class="mb-0">{{ $t('informacion') }}</h3>
        </b-card-header>
        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col md="4">
              <b-form-group label-for="nombre">
                <template v-slot:label>
                  {{ $t('nombre') }} <span class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" id="nombre" v-model="condicion.nombre" required
                  :placeholder="$t('nombre')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="nombreIngles">
                <template v-slot:label>
                  {{ $t('nombre_ingles') }}
                </template>
                <b-form-input :disabled="!editMode" id="nombreIngles" v-model="condicion.nombreIngles"
                  :placeholder="$t('nombre_ingles')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="codigo">
                <template v-slot:label>
                  {{ $t('codigo') }}
                </template>
                <b-form-input :disabled="!editMode" id="codigo" v-model="condicion.codigo"
                  :placeholder="$t('codigo')"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group label-for="observacion">
                <template v-slot:label>
                  {{ $t('observacion') }}
                </template>
                <b-form-textarea :disabled="!editMode" id="observacion" v-model="condicion.observacion" rows="3"
                  :placeholder="$t('observacion')"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button v-if="editMode && puedeEditar" type="submit" variant="primary" class="ml-3">
            {{ $t('guardar') }}
          </b-button>
        </b-form>
      </b-container>
    </base-header>
  </div>
</template>

<script>
import condicionService from '@/api/condicionService';
import utilsService from '@/api/utilsService';
import Swal from 'sweetalert2';

export default {
  name: 'CondicionDetalle',
  data() {
    return {
      condicion: {},
      editMode: false,
    };
  },
  computed: {
    puedeEditar() {
      return utilsService.puedeEscribir() && utilsService.getRol() !== 'ventas inex';
    },
  },
  async beforeMount() {
    const id = this.$route.params.id;
    this.condicion = await condicionService.get(id);
  },
  methods: {
    async cancelEdit() {
      if (this.editMode) {
        const id = this.$route.params.id;
        this.condicion = await condicionService.get(id);
      }
      this.editMode = !this.editMode;
    },
    submitForm() {
      if (!this.puedeEditar) return;
      Swal.fire({
        title: this.$t('esta_seguro'),
        text: this.$t('revisa_datos'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('actualizar'),
        cancelButtonText: this.$t('cancelar'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            Swal.fire({
              html: '<div style="display:flex;align-items:center;justify-content:center;">' +
                    '<img src="/img/others/loading.gif" alt="Loading" style="width:50px;height:50px;margin-right:15px;">' +
                    `<div><h3 style="color:#006393;">${this.$t('actualizando')}</h3></div>` +
                    '</div>',
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            const id = this.$route.params.id;
            const response = await condicionService.update(this.condicion, id);
            if (!response) {
              Swal.fire({ icon: 'error', title: 'Oops...', text: this.$t('error_inesperado') });
              return;
            }

            Swal.fire({
              title: this.$t('actualizado_correctamente'),
              icon: 'success',
              showConfirmButton: false,
              timer: 2000,
            });
            this.editMode = false;
            this.condicion = await condicionService.get(id);
          } catch (error) {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: (error && error.message) ? error.message : this.$t('error_inesperado'),
            });
          }
        } else if (result.isDenied) {
          Swal.close();
        }
      });
    },
  },
};
</script>
